import React, { useState, useEffect } from 'react';
import EirCustomerDetailsContainer from './EirCustomerDetailsContainer';
import EirInstallationDetailsContainer from './EirInstallationDetailsContainer';
import EirPaymentDetailsContainer from './EirPaymentDetailsContainer';
import { isMobileOnly } from "react-device-detect";
import { pushCheckoutEvent } from '../../utils/Analytics';

export default function EirCustomerCheckoutContainer(props) {

    const [customerCheckoutActiveStep, setCustomerCheckoutActiveStep] = useState(0);
    const steps = getSteps().length;
    const [stepperClickablefromID, setStepperClickablefromID] = useState(false);
    function getSteps() {
        if (JSON.parse(localStorage.getItem("eir_be_data"))) {
            if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal) {//checking for general order
                if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.customerType == "NEW") {
                    if (isMobileOnly) {
                        return ['Customer', 'Installation', 'Payment'];
                    }
                    else {
                        return ['Customer Details', 'Installation Details', 'Payment Details'];
                    }
                }
                else if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.customerType == JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.broadband.plan.type) {
                    if (isMobileOnly) {
                        return ['Customer', 'Payment'];
                    }
                    else {
                        return ['Customer Details', 'Payment Details'];
                    }
                }
                else {
                    if (isMobileOnly) {
                        return ['Customer', 'Installation', 'Payment'];
                    }
                    else {
                        return ['Customer Details', 'Installation Details', 'Payment Details'];
                    }
                }
            } else {//for stand alone journey as there is no prequal data
                if (isMobileOnly) {
                    return ['Customer', 'Payment'];
                }
                else {
                    return ['Customer Details', 'Payment Details'];
                }
            }
        }
    }
    const handleBack = () => {
        ((customerCheckoutActiveStep !== 0) && document.querySelector(".checkoutStep_back").click());
    };

    const handleNext = () => {
        ((customerCheckoutActiveStep !== steps - 1) && document.querySelector(".checkoutStep_next").click());
    };
    const BottomNextText = (steps == 3 ? (customerCheckoutActiveStep == 0 ? 'Installation Details' : (customerCheckoutActiveStep == 1 ? 'Payment Details' : '')) : (customerCheckoutActiveStep == 0 ? 'Payment Details' : ''));

    useEffect(() => {
        switch (customerCheckoutActiveStep) {    
            case (0): {
                $("#checkout-step-0").removeClass("checkout-hide-step-element");
                $("#checkout-step-1, #checkout-step-2, #checkout-step-3").addClass("checkout-hide-step-element");
                window.history.replaceState(null, '', "/checkout/customer-details");
                pushCheckoutEvent({ 'step': 1, 'option': 'Customer Details | eir.ie' });
                setDataLayer(`Checkout - Step ${customerCheckoutActiveStep} : Customer Details | eir.ie`, '/checkout/customer-details')
                break;
            }
            case (1): {
                $("#checkout-step-1").removeClass("checkout-hide-step-element");
                $("#checkout-step-0, #checkout-step-2").addClass("checkout-hide-step-element");
                let [title, path] =  steps == 3 ? [`Checkout - Step ${customerCheckoutActiveStep} : Installation Details | eir.ie`, "/checkout/installation-details"] 
                : [`Checkout - Step ${customerCheckoutActiveStep} : Payment Details | eir.ie`,"/checkout/payment-details"]
                window.history.replaceState(null, '', path);
                steps === 3 ? pushCheckoutEvent({ 'step': 2, 'option': 'Installation Details | eir.ie' }) : pushCheckoutEvent({ 'step': 3, 'option': 'Payment Details | eir.ie' });
                setDataLayer(title, path)
                break;
            }
            case (2): {
                $("#checkout-step-2").removeClass("checkout-hide-step-element");
                $("#checkout-step-0, #checkout-step-1").addClass("checkout-hide-step-element");
                window.history.replaceState(null, '', "/checkout/payment-details");
                pushCheckoutEvent({ 'step': 3, 'option': 'Payment Details | eir.ie' });
                setDataLayer(`Checkout - Step ${customerCheckoutActiveStep} : Payment Details | eir.ie`, "/checkout/payment-details")
                break;
            }
            default: {
            }
        }
    }, [customerCheckoutActiveStep]);
    const setCustomerCheckoutActiveSteps = function (index) {
        setCustomerCheckoutActiveStep(index);
    }
    const setDataLayer = (title, url) => {
        dataLayer.push({
            'event': 'VirtualPageview',
            'virtualPageURL': url,
            'virtualPageTitle': title
        });
    }
    return (
        <div className="customerCheckoutContainer ">
            {steps == 3 ?
                <div>
                    <div id="checkout-step-0" className={(customerCheckoutActiveStep === 0) ? "" : "checkout-hide-step-element"}>
                        <EirCustomerDetailsContainer
                            setCustomerCheckoutActiveStep={setCustomerCheckoutActiveSteps}
                            stepperClickablefromID={stepperClickablefromID}
                            customerCheckoutActiveStep={customerCheckoutActiveStep}
                            BottomNextText={BottomNextText}
                            steps={steps}
                            handleNext={handleNext}
                            handleBack={handleBack}
                        ></EirCustomerDetailsContainer>
                    </div>

                    <div id="checkout-step-1" className={(customerCheckoutActiveStep === 1) ? "" : "checkout-hide-step-element"}>
                        <EirInstallationDetailsContainer
                            setCustomerCheckoutActiveStep={setCustomerCheckoutActiveSteps}
                            stepperClickablefromID={stepperClickablefromID}
                            setStepperClickablefromID={setStepperClickablefromID}
                            customerCheckoutActiveStep={customerCheckoutActiveStep}
                            BottomNextText={BottomNextText}
                            steps={steps}
                            handleNext={handleNext}
                            handleBack={handleBack}
                        ></EirInstallationDetailsContainer>
                    </div>

                    <div id="checkout-step-2" className={(customerCheckoutActiveStep === 2) ? "" : "checkout-hide-step-element"}>
                        <EirPaymentDetailsContainer
                            setCustomerCheckoutActiveStep={setCustomerCheckoutActiveSteps}
                            customerCheckoutActiveStep={customerCheckoutActiveStep}
                            BottomNextText={BottomNextText}
                            steps={steps}
                            handleNext={handleNext}
                            handleBack={handleBack}
                        >
                        </EirPaymentDetailsContainer>
                    </div>
                </div>
                :
                <div>
                    <div id="checkout-step-0" className={(customerCheckoutActiveStep === 0) ? "" : "checkout-hide-step-element"}>
                        <EirCustomerDetailsContainer
                            setCustomerCheckoutActiveStep={setCustomerCheckoutActiveSteps}
                            stepperClickablefromID={stepperClickablefromID}
                            customerCheckoutActiveStep={customerCheckoutActiveStep}
                            BottomNextText={BottomNextText}
                            steps={steps}
                            handleNext={handleNext}
                            handleBack={handleBack}
                        ></EirCustomerDetailsContainer>
                    </div>
                    <div id="checkout-step-1" className={(customerCheckoutActiveStep === 1) ? "" : "checkout-hide-step-element"}>
                        <EirPaymentDetailsContainer
                            setCustomerCheckoutActiveStep={setCustomerCheckoutActiveSteps}
                            customerCheckoutActiveStep={customerCheckoutActiveStep}
                            BottomNextText={BottomNextText}
                            steps={steps}
                            handleNext={handleNext}
                            handleBack={handleBack}
                        >
                        </EirPaymentDetailsContainer>
                    </div>
                </div>
            }
        </div>
    );
}